import React, { useEffect, useState } from 'react';
import { Modal, Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import { DSP_PAYMENT_METHOD_OPTIONS, type DspPaymentMethod } from '../../constants/dspPaymentMethod';

interface DspPaymentMethodModalProps {
    open: boolean;
    title: string;
    /** 编辑场景下的当前值；确认付款场景不传，须财务显式选择 */
    initialValue?: DspPaymentMethod | null;
    confirmLoading?: boolean;
    onOk: (value: DspPaymentMethod) => void;
    onCancel: () => void;
}

/**
 * 选择 DSP 账单付款方式的弹窗，确认付款与编辑付款方式共用。无选中值时确定按钮禁用。
 */
const DspPaymentMethodModal: React.FC<DspPaymentMethodModalProps> = ({
    open,
    title,
    initialValue,
    confirmLoading = false,
    onOk,
    onCancel
}) => {
    const { t } = useTranslation();
    const [value, setValue] = useState<DspPaymentMethod | null>(initialValue ?? null);

    // 每次打开重置为初始值，避免上一次的选择残留
    useEffect(() => {
        if (open) {
            setValue(initialValue ?? null);
        }
    }, [open, initialValue]);

    return (
        <Modal
            open={open}
            title={title}
            okButtonProps={{ disabled: !value }}
            confirmLoading={confirmLoading}
            onOk={() => value && onOk(value)}
            onCancel={onCancel}
            destroyOnClose
        >
            <div className="mb-2">{t('dspBillPayment.paymentMethod.placeholder')}</div>
            <Radio.Group value={value} onChange={e => setValue(e.target.value)}>
                <div className="flex flex-col gap-2">
                    {DSP_PAYMENT_METHOD_OPTIONS.map(option => (
                        <Radio key={option.value} value={option.value}>
                            {t(option.labelKey)}
                        </Radio>
                    ))}
                </div>
            </Radio.Group>
        </Modal>
    );
};

export default DspPaymentMethodModal;
